import React, { useState } from "react";
import Header from "../../components/Header";
import Footer from "./SignUp/Footer";
import StyleLogin from "./SignUp/styles";
import { useFormik } from "formik";
import FormError from "../../components/FormError";
import { publicFetchWithoutAuthorization } from "../../util/fetch";
const Forgot = () => {
  const [forgotError, setForgotError] = useState(false);
  const [forgotErrorMsg, setForgotErrorMsg] = useState("");
  const [loading, setloading] = useState(false);
  const forgotFormFields = useFormik({
    initialValues: { email: "" },
    validate: (values) => {
      const errors = {};
      const EMAIL_PATTERN =
        /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const correctEmailAddress = EMAIL_PATTERN.test(
        String(values.email).toLowerCase()
      );
      if (!values.email) {
        errors.email = "Email address is required!";
      }
      if (values.email && !correctEmailAddress) {
        errors.email = "Email address is invalid!";
      }
      return errors;
    },
    onSubmit: async (values, { setSubmitting }) => {
      setloading(true);
      await publicFetchWithoutAuthorization
        .post(`/auth/request-password-reset-link?email=${values?.email}`)
        .then(({ data }) => {
          setSubmitting(false);
          window.location.href = "/check";
          forgotFormFields.resetForm();
          setloading(false);
        })
        .catch((error) => {
          const errMsg = error.response.data.error;
          setForgotError(true);
          setForgotErrorMsg(errMsg);
          console.log("retro");
          setloading(false);
          setTimeout(() => {
            setForgotError(false);
          }, 3500);
        });
    },
  });
  return (
    <>
      <Header />
      <StyleLogin>
        <h1 className="login-title">Forgot your password?</h1>
        <p
          style={{ width: "35%", textAlign: "center", margin: "1rem 0" }}
          className="forgot-text"
        >
          Enter your email address below and we will send you a link where you
          can enter a new password.
        </p>
        <form onSubmit={forgotFormFields.handleSubmit}>
          {forgotError && <FormError text={forgotErrorMsg} />}

          <div className="wrapper double-wrapper-left">
            <div className="label">
              <p>Email address</p>
            </div>
            <input
              name="email"
              type="email"
              placeholder="Type your email"
              style={{ width: "100%" }}
              className="input-email"
              value={forgotFormFields.values.email}
              onChange={forgotFormFields.handleChange}
              onBlur={forgotFormFields.handleBlur}
            />
          </div>
          {forgotFormFields.touched.email && forgotFormFields.errors.email ? (
            <span className="text-base font-serif small text-red-700">
              {forgotFormFields.errors.email}
            </span>
          ) : null}

          <button
            type="submit"
            style={{ margin: "2rem 0" }}
            className="btn login-btn"
          >
            {loading ? <i class="fa fa-spinner fa-spin"></i> : "Reset password"}
          </button>
        </form>
        <Footer />
      </StyleLogin>
    </>
  );
};
export default Forgot;
